import React from 'react'
import OrdiniImportiTaylorMadeTemplate from '../../components/template/OrdiniImportTaylorMade/OrdiniImportTaylorMade'
import PropTypes from 'prop-types'
import { PAGINEDETAIL } from '../../utils/endpoint'
import { api, getApiClient } from '../../utils'

const OrdiniImportTaylorMade = ({ page }) => {
  return (
    <>
      <OrdiniImportiTaylorMadeTemplate page={page} />
    </>
  )
}

export async function getServerSideProps({ params, locale, req }) {
  const api = getApiClient(req)
  try {
    const pageResponse = await api.get(PAGINEDETAIL, {
      params: {
        chiave: 'ordini-import-taylor-made',
        lang: locale,
      },
    })
    const page = await pageResponse.data

    const toolbarProps = { toolbarPage: page }

    return { props: { page, ...toolbarProps } }
  } catch (error) {
    return { props: { statusCode: 500 } }
  }
}

OrdiniImportTaylorMade.propTypes = {
  page: PropTypes.object,
}

export default OrdiniImportTaylorMade
